export default function tableTransformation(transformation, { data, headers, scheme }) {
  if (!transformation || !transformation.cmd) throw new Error(`${JSON.stringify(transformation)} is not a transformation { cmd, ... }`);
  switch (transformation.cmd) {
    case "change-column-type": {
      const { columnId, colType } = transformation;
      const scheme1 = { ...scheme, columns: [...scheme.columns] };
      scheme1.columns[columnId] = colType;
      return {
        data,
        headers,
        scheme: scheme1,
      };
    }
    case "map-column": {
      const { columnId, func } = transformation;
      const data1 = data.map((originalRow) => {
        const clonedRow = Array.isArray(originalRow) ? [ ...originalRow ] : { ...originalRow };
        try {
          const fn = new Function("value", `return (() => ${func})();`);
          clonedRow[columnId] = fn(originalRow[columnId]);
          if (typeof clonedRow[columnId] === "object" && clonedRow[columnId]) {
            throw new Error(`Object value ${JSON.stringify(clonedRow[columnId])} is not expected`);
          }
          if (scheme.columns[columnId].type === "number" && isNaN(clonedRow[columnId])) {
            throw new Error(`not a number`);
          }
        } catch (e) {
          clonedRow[columnId] = { error: e };
        }
        return clonedRow;
      });
      const scheme1 = { ...scheme, columns: [...scheme.columns] };
      if (scheme1.columns[columnId].type === "number") {
        if (data1.some((row) => isNaN(+row[columnId]))) {
          scheme1.columns[columnId].type = "string";
        }
      } else {
        scheme1.columns[columnId].type = "string";
      }
      return {
        data: data1,
        headers: headers,
        scheme: scheme1,
      };
    }
    default: {
      console.error(transformation);
      throw new Error(`Unknown transformation "${transformation.cmd}"`);
    }
  }
}

